import common from './common'
import api from './api'
import auth from './authentification'
import workspace from './workspace'
import campaign from './campaign'
import badge from './badge'
import menu from './menu'
import settings from './settings'
import challenge from './challenge'
import customer from './customer'
import events from './events'
import contest from './contest'
import manager from './manager'
import libraries from './libraries'
import notifications from './notifications'
import waves from './waves'
import wheel from './wheel'
import banner from './banner'
import tooltip from './tooltip'

export default {
  'common': common,
  'api': api,
  'menu': menu,
  'auth': auth,
  'workspace': workspace,
  'campaign': campaign,
  'badge': badge,
  'settings': settings,
  'challenge': challenge,
  'customer': customer,
  'contest': contest,
  'events': events,
  'manager': manager,
  'libraries': libraries,
  'notifications': notifications,
  'waves': waves,
  'wheel': wheel,
  'banner': banner,
  'tooltip': tooltip
}



// WEBPACK FOOTER //
// ./src/translations/en/en.js